import _ from 'lodash'
import {addIdToMap, getCustomId} from '../utils'
import {DATA_TYPES} from '../../../../constants/constants'
import {addNamespaceToStructure} from '../componentDeserializationStructure'
import type {DeserializeComponentParams} from '../types'

export const updateComponentBindingsStructure = (deserializationParams: DeserializeComponentParams) => {
    const {compStructure, customId, mappers} = deserializationParams

    const bindingsData = compStructure.bindings
    if (!_.isObject(bindingsData)) return

    const {oldToNewIdMap} = mappers ?? {oldToNewIdMap: {}}
    deserializationParams.customId = getCustomId(oldToNewIdMap, bindingsData, customId)

    const bindingsQuery = addNamespaceToStructure(
        deserializationParams,
        bindingsData,
        DATA_TYPES.bindings,
        oldToNewIdMap
    )
    if (bindingsQuery) {
        compStructure.bindingsQuery = bindingsQuery
        addIdToMap(bindingsData, bindingsQuery, oldToNewIdMap)
    }
}
